<template>
    <AdminLayout>
        <div class="text-end">
            <button @click="addNewCandidate" type="button" class="btn btn-sm btn-success"> + Add Candidate</button>
        </div>
        <div class="table-responsive">
            <form v-on:submit.prevent="search">

                <table class="table align-middle">
                    <thead>
                        <tr>
                            <th class="text-center">#</th>
                            <th class="text-center">Name</th>
                            <th class="text-center">Agency</th>
                        </tr>
                        <tr>
                            <th>
                                <input v-model="candidatesSearchObj.userPK" class="form-control" />
                            </th>
                            <th>
                                <input v-model="candidatesSearchObj.name" class="form-control" />
                            </th>
                            <th>
                                <input v-model="candidatesSearchObj.agency" class="form-control" />
                                <button type="submit" class="d-none" />
                            </th>


                        </tr>
                    </thead>
                    <tbody>
                        <tr style="cursor: pointer;" @click.prevent="getCandidateInfo(candidate.id)"
                            v-for="candidate in candidates" :key="candidate.id">
                            <td>{{ candidate.userPK }}</td>
                            <td>{{ candidate.name }}</td>
                            <td>{{ candidate.agency }}</td>
                            <td><button type="button" class="btn btn-sm btn-danger"
                                    @click.stop.prevent="deleteCandidate(candidate.id)">
                                    <i class="bi bi-trash"></i>
                                </button></td>
                        </tr>
                    </tbody>
                </table>
            </form>

        </div>
        <MediumSizedModal title="Candidate Information" @close="toggleModal" :show="showModal">
            <CandidateInfo :id="selectedId" @next="handleNext" @prev="handlePrev" @reset="onReset" />
        </MediumSizedModal>
    </AdminLayout>
</template>


<script setup>
import { onMounted, ref } from 'vue';
import candidateService from '@/services/candidateService'
import spinnerService from '@/services/spinnerService';
import CandidateInfo from '@/components/candidates/CandidateInfo.vue';
import MediumSizedModal from '@/components/modals/MediumSizedModal.vue';
import confirmationService from '@/services/confirmationService';
import toastService from '@/services/toastService';
import AdminLayout from '@/layouts/AdminLayout.vue';
const candidatesSearchObj = ref({});
const candidates = ref([]);
const selectedId = ref('');
const showModal = ref(false);
const currentIndex = ref(-1);

const addNewCandidate = () => {
    selectedId.value = '00000000-0000-0000-0000-000000000000';
    toggleModal();
}
const onReset = () => {
    selectedId.value = '';
    currentIndex.value = -1;
};
const handleNext = () => {
    if (currentIndex.value < candidates.value.length - 1) {
        currentIndex.value += 1;
        selectedId.value = candidates.value[currentIndex.value].id;
    }
};
const handlePrev = () => {
    if (currentIndex.value > 0) {
        currentIndex.value -= 1;
        selectedId.value = candidates.value[currentIndex.value].id;
    }
};

const search = async () => {
    spinnerService.show();
    candidates.value = await candidateService.search(candidatesSearchObj.value);
    spinnerService.hide();
}
const toggleModal = () => {
    showModal.value = !showModal.value;
};
const getCandidateInfo = async (id) => {
    ///const resp = await candidateService.getInfo(id);
    //alert(JSON.stringify(resp));
    const idx = candidates.value.findIndex((x) => x.id === id);
    currentIndex.value = idx;
    selectedId.value = id;
    toggleModal();
}

const deleteCandidate = async (id) => {
    const confirmed = await confirmationService.show("Are you sure you want to delete this candidate?");
    if (!confirmed) return;
    spinnerService.show();
    const response = await candidateService.deleteContestant(id);
    if (response.success) {
        toastService.success("Candidate deleted successfully!");
        search();
    }
    else {
        toastService.error(response.message);
    }
    spinnerService.hide();
}

onMounted(() => {
    search();
});

</script>